<template>
  <div style="height: inherit">
    <template v-if="!showQRcodeModal">
    <div class="top" ref="p1">
      <div class="iccid"><span>充值号：{{ operator.short_number?operator.short_number:iccid }}</span> <span class="cp-btn"  v-clipboard:copy="operator.short_number?operator.short_number:iccid" v-clipboard:success="onCopySuccess"
                                                                                                           v-clipboard:error="onCopyError">复制</span></div>
      <div class="expire">到期时间：{{expireDate?expireDate.replace(/\-/g,'/'):'--/--/--'}}</div>
      <template v-if="operator.system">
      <template  v-if="operator.system=='SHUANGKAONE'">
        <div class="status" v-for="(item,index) in shuangka" v-if="item.iccid">
          <div class="status-1">{{operatorType[index]}}状态：<span v-if="item.statusName" :class="(item.statusName.indexOf('停') === -1 || item.statusName.indexOf('风险') === -1) ? 'success':'error'">{{item.statusName}}</span></div>
          <div class="status-2">{{operatorType[index]}}实名：<span :class="item.auth=='1'?'success':'error'">{{item.auth=='1'?'已实名':'未实名'}}</span></div>
          <van-loading type="spinner" class="loading" size=".28rem" v-if="item.loading==true" />
        </div>
      </template>
      <div class="status" v-else>
        <div class="status-1" v-if="simStatusName">卡状态：<span :class="(simStatusName.indexOf('停') === -1 || simStatusName.indexOf('风险') === -1) ? 'success':'error'">{{simStatusName}}</span></div>
        <div class="status-2">实名：<span :class="simAuthStatusName=='已实名'?'success':'error'">{{simAuthStatusName}}</span></div>
      </div>
      </template>
      <div class="last">
        <div class="amount" v-if="totalUsage <= 500">
          <div>{{totalUsage}}G</div>
          <div>总流量</div>
        </div>
        <div class="amount">
          <div>{{ usedUsage }}G</div>
          <div>已用流量</div>
        </div>
        <div class="amount" v-if="totalUsage <= 500">
          <div>{{ remainUsage }}G</div>
          <div>剩余流量</div>
        </div>
        <div class="amount">
          <a href="javascript:;" @click="$router.push({name:'bind',query:{nostorage:1}})" class="editcard">更换卡号</a>
        </div>
      </div>
    </div>
    <div class="pagebottom" ref="p2">
      <div class="box1">
        <div class="title">流量套餐</div>
        <div class="btn-group">
          <div class="btn-item" @click="$router.push({name:'recharge',query:{iccid:iccid}})">
            <img src="../assets/images/tao_03.png" />
            <span>购买套餐</span>
          </div>
          <div class="btn-item" @click="$router.push({name:'order',query:{iccid:iccid}})">
            <img src="../assets/images/orders.png" />
            <span>充值记录</span>
          </div>
          <div class="btn-item" @click="$router.push({name:'usage',query:{iccid:iccid}})">
            <img src="../assets/newimg/chaxun.png" />
            <span>流量查询</span>
          </div>
        </div>
      </div>

      <div class="box1">
        <div class="title">我的服务</div>
        <div class="btn-group">
          <div class="btn-item" @click="flushPage">
            <img src="../assets/newimg/shuaxin.png" />
            <span>刷新网络</span>
          </div>
          <div class="btn-item" @click="checkCard">
            <img src="../assets/newimg/zhenduan.png" />
            <span>诊断</span>
          </div>
          <a class="btn-item"  v-if="customerUrl" :href="customerUrl" >
            <img src="../assets/newimg/kefu.png" />
            <span>客服</span>
          </a>
          <template v-if="operator.system =='SHUANGKAONE'">
            <div class="btn-item" @click="showAuthDialog=true">
              <img src="../assets/newimg/shiming.png" />
              <span>实名</span>
            </div>
          </template>
          <template v-else-if="operator.authUrl">
            <template v-if="( operator.authUrl.indexOf('10010') === -1 && operator.authUrl.indexOf('auth10646') === -1 || !wxReady) ">
              <a class="btn-item" v-if="operator.authUrl && simAuthStatusName=='未实名'" :href="operator.authUrl">
                <img src="../assets/newimg/shiming.png" />
                <span>实名</span>
              </a>
            </template>
            <template v-else>
              <div class="btn-item" v-if="operator.authUrl && simAuthStatusName=='未实名'">
                <img src="../assets/newimg/shiming.png" />
                <span>实名</span>
                <wx-open-launch-weapp
                  id="launch-btn"
                  class="btn-item"
                  appid="wxa5b3db0cd2c5a1ed"
                  style="position: absolute;
                      left: 0;
                      top:0;
                      width: 100%;
                      height: 100%;
                      margin: 0;
                      padding: 0;
                      opacity: 0"
                  :path="'pages/login/index?iccid='+operator.iccid" >
                  <script type="text/wxtag-template">
                    <style>
                      div{
                        position: absolute;
                        left: 0;
                        top:0;
                        margin: 0;
                        padding: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0
                      }
                    </style>
                    <div class="btn-item">

                    </div>
                  </script>
                </wx-open-launch-weapp>
              </div>
            </template>
          </template>
          <div class="btn-item" v-if="operator.system=='SHUANGKAONE' && operator.netType>0" @click="$router.push({name:'shengji',query:{iccid:iccid}})">
            <img src="../assets/newimg/shengji.png" />
            <span>套餐升级</span>
          </div>
          <div class="btn-item" v-if="operator.system=='SHUANGKAONE'" @click="$router.push({name:'device',query:{iccid:operator.short_number?operator.short_number:iccid}})">
            <img src="../assets/newimg/shebeiguanli.png" />
            <span>设备管理</span>
          </div>
          <div class="btn-item" @click="showQRcodeModal=true">
            <img src="../assets/newimg/gongzhonghao.png" />
            <span>公众号</span>
          </div>
          <div class="btn-item" @click="$router.push({name:'feedback',query:{iccid:operator.short_number?operator.short_number:iccid}})">
            <img src="../assets/newimg/tousu.png" />
            <span>官方投诉</span>
          </div>
          <div  class="btn-item" v-if="operator.exchangeSwitch==1" @click="changeCard(iccid)">
            <img src="../assets/newimg/huanxin.png" />
            <span>申请更换</span>
          </div>
          <div class="btn-item" @click="$router.push({name:'bind',query:{nostorage:1}})">
            <img src="../assets/newimg/tuichu.png" />
            <span>退出登录</span>
          </div>
        </div>
      </div>
    </div>
    </template>
    <template v-else>
      <div class="gongzhonghao">
        <img src="../assets/images/pagegongzhonghao_01.png" class="topimg" @click="showQRcodeModal=false"/>
        <div class="buttom">
          <img :src="operator.qrcode" class="qrcode">
          <a>长按关注公众号</a>
        </div>
      </div>
    </template>

    <van-dialog
      v-model="showCopy"
      title="请先完成官方实名"
      :show-confirm-button="false"
      v-if="operator.authUrl.indexOf('10099') === -1 "
    >
      <div>
        <div style="display: flex;border-top: 1px solid #eee;margin-top: 10px;font-size: 16px;">
          <div @click="showCopy=false" style="width: 100%;line-height: 40px;text-align: center;color: #999988;border-right: 1px solid #eee;">取消</div>
          <div v-if="( operator.authUrl.indexOf('10010') === -1 && operator.authUrl.indexOf('auth10646') === -1 ) || wxReady == false" @click="handleCopyIccid" style="width: 100%;line-height: 40px;text-align: center;color:#2497e5">确定</div>
          <wx-open-launch-weapp
            v-else
            id="launch-btn"
            appid="wxa5b3db0cd2c5a1ed"
            style="display:inline-block;border:none;width: 100%"
            :path="'pages/login/index?iccid='+operator.iccid" >
            <script type="text/wxtag-template">
              <style>
                .btn{width: 100%;line-height: 40px;text-align: center;color:#2497e5;font-size: 16px;background: #fff;border: none;}
              </style>
              <button class="btn">打开小程序</button>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model="showCopy"
      title="实名提示"
      v-else
      show-cancel-button
      confirmButtonText="已复制，去实名"
      @confirm="handleCopyIccid"
    >
      <div style="padding: .2rem 0">
        <div>请先复制号码后，完成官方实名</div>
        <div>{{iccid}} <a v-clipboard:copy="iccid" style="color: #a70000" v-clipboard:success="onCopySuccess"
                          v-clipboard:error="onCopyError">
          <svg t="1622559508450" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="3548" width="16" height="16">
            <path
              d="M720 192h-544A80.096 80.096 0 0 0 96 272v608C96 924.128 131.904 960 176 960h544c44.128 0 80-35.872 80-80v-608C800 227.904 764.128 192 720 192z m16 688c0 8.8-7.2 16-16 16h-544a16 16 0 0 1-16-16v-608a16 16 0 0 1 16-16h544a16 16 0 0 1 16 16v608z"
              p-id="3549"></path>
            <path
              d="M848 64h-544a32 32 0 0 0 0 64h544a16 16 0 0 1 16 16v608a32 32 0 1 0 64 0v-608C928 99.904 892.128 64 848 64z"
              p-id="3550"></path>
            <path
              d="M608 360H288a32 32 0 0 0 0 64h320a32 32 0 1 0 0-64zM608 520H288a32 32 0 1 0 0 64h320a32 32 0 1 0 0-64zM480 678.656H288a32 32 0 1 0 0 64h192a32 32 0 1 0 0-64z"
              p-id="3551"></path>
          </svg>
          点击复制</a></div>
      </div>
    </van-dialog>

    <van-action-sheet
      v-model="cardModal"
      :actions="cardlist"
      cancel-text="取消"
      @select="handleChooseCard"
    />
    <van-dialog
      v-model="inputImeiModal"
      title="输入IMEI"
      show-cancel-button
      @confirm="handleImeiInput"
    >
      <van-cell-group>
        <van-field v-model="imei" type="number" placeholder="请输入设备IMEI"/>
      </van-cell-group>
    </van-dialog>
<!--    <van-dialog v-model="showQRcodeModal" :showConfirmButton="false" title="长按关注官方公众号">

      <img :src="qrcodeurl" style="display: block;width: 100%;"/>
      <div>续费查询，24小时客服在线</div>
      <a v-clipboard:copy="iccid" v-clipboard:success="onCopySuccess"
         v-clipboard:error="onCopyError" style="padding: .2rem 0;display: block;color: #3a8ee6">复制号码
      </a>
    </van-dialog>-->

    <van-dialog v-model="showChangeModel" :showConfirmButton="false" title="转套餐提示">
      <div style="padding: 20px;">
        <div class="change-tips">此卡号已申请换卡，请确认新卡号是否为以下号码，<span
          style="font-size:16px;color:#ff2000;">未收到卡请勿转套餐，关闭提示继续使用原卡</span></div>
        <fieldset class="md-field">
          <div class="md-field-content">
            <div class="md-field-item md-input-item is-solid is-browser left normal">
              <div class="md-field-item-content">
                <div class="md-field-item-control">
                  <input max="20" disabled name="iccid" v-model="changeform.newiccid" placeholder="" maxlength=""
                         autocomplete="off"
                         type="text" class="md-input-item-input">
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="md-field">
          <div @click="handleChangeCardClick" class="md-field-content">
            <div class="md-button primary block" style="height: .6rem;line-height: .6rem;font-size: .4rem;">
              <div class="md-button-inner">
                <div class="md-button-content" style="font-size: .34rem"><span>转移套餐</span></div>
              </div>
            </div>
          </div>
        </fieldset>
        <div class="md-field">
          <div class="md-field-content">
            <div @click="showChangeModel=false" class="md-button primary active block" style="background: #ff2c27;">
              <div class="md-button-inner">
                <div class="md-button-content"><span>关闭提示</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <van-popup v-model="showAuthDialog" position="bottom" >
      <div class="auth-modal">
        <div class="title">设备实名才可以使用</div>
        <div class="auth-box">
          <a class="auht-item" v-if="shuangka.dianxin && ( operator.is0601==false ||  (!shuangka.yidong || shuangka.yidong.auth==1 ))"  :href="shuangka.dianxin.auth == 1?'javascript:;':shuangka.dianxin.authUrl">
            <div :class="shuangka.dianxin.auth == 0?'error':''">{{shuangka.dianxin.auth == 1 ?'已实名':'未实名'}}</div>
            <div>电信实名</div>
          </a>
          <template v-if="shuangka.liantong && (operator.is0601==false  || ( (!shuangka.dianxin || shuangka.dianxin.auth==1) && (!shuangka.yidong || shuangka.yidong.auth==1)) ) && (operator.netType==3 || operator.netType==5 || operator.netType==7 || operator.netType==0)">
            <template v-if="shuangka.liantong.auth == 1 ">
              <div class="auht-item" >
                <div>已实名</div>
                <div>联通实名</div>
              </div>
            </template>
            <template v-else>
              <template v-if="!wxReady || ( shuangka.liantong.authUrl && shuangka.liantong.authUrl.indexOf('10646') === -1)">
                <a class="auht-item" v-if="" :href="shuangka.liantong.authUrl">
                  <div class="error">未实名</div>
                  <div>联通实名</div>
                </a>
              </template>
              <template v-else>
                <div class="auht-item" v-if="shuangka.liantong" style="position: relative">
                  <div class="error">未实名</div>
                  <div>联通实名</div>
                  <wx-open-launch-weapp
                    id="launch-btn"
                    class="btn-item"
                    appid="wxa5b3db0cd2c5a1ed"
                    style="position: absolute;
                      left: 0;
                      top:0;
                      width: 100%;
                      height: 100%;
                      margin: 0;
                      padding: 0;
                      opacity: 0"
                    :path="'pages/login/index?iccid='+shuangka.liantong.iccid" >
                    <script type="text/wxtag-template">
                      <style>
                        div{
                          position: absolute;
                          left: 0;
                          top:0;
                          margin: 0;
                          padding: 0;
                          width: 100%;
                          height: 100%;
                          opacity: 0
                        }
                      </style>
                      <div class="btn-item">

                      </div>
                    </script>
                  </wx-open-launch-weapp>
                </div>
              </template>
            </template>
          </template>


          <a class="auht-item" v-if="shuangka.yidong && (operator.netType==4 || operator.netType==6 || operator.netType==7 || operator.netType==0)" :href="shuangka.yidong.auth == 1?'javascript:;':shuangka.yidong.authUrl">
            <div :class="shuangka.yidong.auth == 0?'error':''">{{shuangka.yidong.auth == 1 ?'已实名':'未实名'}}</div>
            <div>移动实名</div>
          </a>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
    //import PackageInfo from "../components/packageInfo"
    //import {swiper, swiperSlide} from "vue-awesome-swiper"
    import Vue from "vue";
    import VueClipboard from 'vue-clipboard2'

    Vue.use(VueClipboard)
    //import "../assets/css/swiper.min.css"

    export default {
        name: "index",
        // components: {PackageInfo, swiper, swiperSlide},
        data() {
            return {
              showAuthDialog:false,
                wxReady:false,
                deviceInfo:{},
                changeform: {},
                showChangeModel: false,
                showCopy: false,
                iccid: '',
                customerUrl:'',
                editSsid:{ssid:'',key:''},
                cardModal: false,
                inputImeiModal: false,
                imei: '',
                shuangka: {
                    liantong: {},
                    dianxin: {},
                    yidong:{}
                },
                operatorType:{
                    liantong:"联通",
                    dianxin:'电信',
                    yidong:'移动',
                },
                /*swiperOption: {
                    centeredSlides: true,
                    slidesPerView:2,
                    spaceBetween : 80,
                    slidesOffsetBefore:-40
                },*/
                cardlist: [],
                packageList: [],
                /*currentPackage: {
                     total:0,
                     used:0,
                     startDate:'--',
                     endDate:'--'
                 },
                 nextPackage: {
                    total:0,
                    used:0,
                    startDate:'--',
                    endDate:'--'
                },*/
                totalUsage: 0,
                usedUsage: 0,
                remainUsage: 0,
                expireDate: '',
                simStatusName: '未知状态',
                simAuthStatus: 0,
                unbindNeedImei: 0,
                operator: {
                  authUrl:''
                },
                rebind: 0,
                change: 0,
                qrcodeurl: '',
                showQRcodeModal: false
            };
        },
        computed: {
            showSaveSsid(){
                if(this.editSsid.ssid.length>0 || this.editSsid.key.length>0){
                    return true
                }
                return false
            },
            swiper() {
                return this.$refs.mySwiper.swiper
            },
            simAuthStatusName() {
                if (this.operator.activeRule == 2 && this.simAuthStatus == 0 && this.totalUsage == 0) {
                    //先续费后实名
                    return '请先续费';
                } else {
                    return this.simAuthStatus == 1 ? '已实名' : '未实名'
                }
            },
            leftPercent() {
                if (this.totalUsage > 0) {
                    return parseInt(this.remainUsage / this.totalUsage * 100);
                } else {
                    return 0;
                }
            },
            pivotText() {
                return "剩余流量" + this.remainUsage + 'G，总流量' + this.totalUsage + 'G，剩余比例 ' + this.leftPercent + '%'
            }
        },
        watch: {
            showQRcodeModal() {
                if (this.showQRcodeModal) {
                    this.showCopy = false
                }
            },
            showCopy() {
                if (this.showCopy && this.showQRcodeModal) {
                    this.showCopy = false
                }
            },
            iccid(value) {
                sessionStorage.setItem('iccid', this.iccid)
                this.subscribeStatus()
                this.queryPackageList();
                this.queryOperatorInfo();
                /*this.queryResetImeiType()*/
                this.queryCardStatus();
            }
        },
      created: function () {
          const oScript = document.createElement('script');
          oScript.type = 'text/javascript';
          oScript.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
          oScript.onload = this.wxmini
          document.body.appendChild(oScript);
            let iccid = this.$route.query.iccid;
            if (iccid) {
                this.iccid = iccid;
            }
            this.queryUserCards();
          this.fetchData('/config/customerUrl',{},res=>{
            if(res.data){
              this.customerUrl = res.data
            }
          })
          this.initWechatJs()
        },
        methods: {
          initpage(){
            const element = this.$refs.p1
            const rect = element.getBoundingClientRect();
            this.$refs.p2.style.minHeight=window.innerHeight - rect.height+'px'
          },
          checkCard(){
            this.$toast.loading('诊断中')
            this.fetchData('/card/check',{iccid:this.iccid},(res)=>{
              this.$toast.loading().close();
              this.$toast(res.msg)
            })
          },
          flushPage(){
            this.$toast.loading('网络重置中')
            setTimeout(()=>{
              this.$toast.loading().close();
              this.$toast('重置成功，请10分钟后重启设备')
            },2000)
          },
          initWechatJs(){
            let url = encodeURIComponent(location.href.split('#')[0])
            this.fetchData('/wechat/jssdk',{url:url},(res)=>{
              if(res.code){
                wx.config(res.data);
                wx.ready(()=>{
                  this.wxReady = true;
                })
              }
            })
          },
          checkCard(){
            this.$toast.loading('诊断中')
            this.fetchData('/card/check',{iccid:this.iccid},(res)=>{
              this.$toast.loading().close();
              this.$toast(res.msg)
            })
          },
            resetDevice(){
                this.$dialog.alert({
                    title: "提示",
                    message: "恢复出厂设置会使设备重启，并且重置WiFi名称和密码，确认恢复出厂",
                    confirmButtonText: '确认',
                    showCancelButton: true
                }).then(() => {

                    this.$toast.loading('发送中', {duration: 0});
                    this.fetchData('/card/resetDevice',{iccid:this.iccid} , res => {
                        this.$toast.clear()
                        if (res.code) {
                            this.$toast.success(res.msg);
                        } else {
                            this.$toast.fail(res.msg);
                        }
                    })

                });
            },
            saveSsid(){
                if(!this.editSsid.ssid || /^[a-zA-z\d_]+$/.test(this.editSsid.ssid) == false){
                    return this.$toast.fail('请输入字母数字下划线组成的WiFi名称');
                }
                if(!this.editSsid.key || /^[a-zA-z\d_]{8,}$/.test(this.editSsid.key) == false){
                    return this.$toast.fail('密码最低8位，支持数字字母下划线');
                }
                this.editSsid.iccid = this.iccid
                this.$toast.loading('发送中', {duration: 0});
                this.fetchData('/card/savessid', this.editSsid , res => {
                    this.$toast.clear()
                    if (res.code) {
                        this.$toast.success(res.msg);
                    } else {
                        this.$toast.fail(res.msg);
                    }
                })


            },
            qieka(type,simIndex){
                this.$dialog.alert({
                    title: "提示",
                    message: "提示指令发送成功后，切换网络过程中，会有短暂断网，设备可能会自动重启，此过程可能需要5分钟",
                    confirmButtonText: '立即切换',
                    showCancelButton: true
                }).then(() => {

                    this.$toast.loading('切换中', {duration: 0});
                    this.fetchData('/card/shuangkaqieka',{simIndex:simIndex,iccid:this.iccid} , res => {
                        this.$toast.clear()
                        if (res.code) {
                            this.$toast.success(res.msg);
                        } else {
                            this.$toast.fail(res.msg);
                        }
                    })

                });
            },
            handleChangeCardClick() {
                if (!this.changeform.mobile) {
                    return this.$toast.fail('请输入手机号码');
                }
                if (!this.changeform.newiccid) {
                    return this.$toast.fail('请输入新卡号');
                }
                if (this.changeform.mobile != this.operator.changeInfo.mobile) {
                    return this.$toast.fail('手机号码与申请换卡时提交的号码不一致');
                }
                this.changeform.iccid = this.iccid;
                this.changeform.remainUsage = this.remainUsage
                this.$toast.loading('转移中', {duration: 0});
                this.fetchData('/change/translate', this.changeform, res => {
                    this.$toast.clear()
                    if (res.code) {
                        this.$toast.success(res.msg);
                        this.$router.push({name: 'bind', query: {cardno: this.changeform.newiccid}})
                    } else {
                        this.$toast.fail(res.msg);
                    }
                })
            },
            subscribeStatus() {
                this.fetchData('/auth/subscribeStatus', {iccid: this.iccid}, res => {
                    if (res.code && res.url) {
                        this.showQRcodeModal = true
                        //this.qrcodeurl = res.url
                    }
                })
            },
            handleCopyIccid() {
                if (this.operator.authUrl) {
                    window.location.href = this.operator.authUrl
                } else {
                    this.$toast.fail('未配置实名网址，请刷新或联系客服');
                }
            },
            handleRechargeBtnClick() {
                if (this.operator.rechargeType < 2) {
                    this.$router.push({name: 'recharge', query: {iccid: this.iccid}})
                } else {
                    this.$router.push({
                        name: 'rechargeBalance',
                        query: {iccid: this.iccid, remainUsage: this.remainUsage}
                    })
                }
            },
            queryOperatorInfo() {
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        if (this.operator.changeInfo && this.operator.changeInfo.newiccid && this.operator.changeInfo.changed == 0) {
                            this.changeform.newiccid = this.operator.changeInfo.newiccid;
                            this.changeform.mobile = this.operator.changeInfo.mobile;
                            this.showChangeModel = true
                        }
                        if (this.operator.changeInfo && this.operator.changeInfo.newiccid && this.operator.changeInfo.changed == 1) {
                            this.$dialog.alert({
                                title: false,
                                message: "此卡已换卡，套餐已切换到新号",
                                confirmButtonText: '查询新卡',
                                showCancelButton: true
                            }).then(() => {
                                this.iccid = this.operator.changeInfo.newiccid;
                            });
                        }
                    } else {
                        this.$toast.fail(res.msg)
                    }
                })
            },
            changeCard(iccid) {
                this.fetchData('/change/getUrl', {iccid: iccid}, (res) => {
                    if (res.code && res.url) {
                        window.location.href = res.url
                    } else {
                        this.$router.push({name: 'change', query: {iccid: iccid}})
                    }
                })
            },
            queryUserCards() {
                this.fetchData('/card/querylist', {}, (res) => {
                    if (res.code) {
                        for (var i in res.data) {
                            let card = res.data[i];
                            this.cardlist.push({
                                name: card.iccid,
                                value: card.iccid
                            })
                            if (card.default == 1 && !this.iccid) {
                                this.iccid = card.iccid;
                            }
                        }
                    } else {
                        this.$router.push({name: 'bind'})
                    }
                })
            },
            queryPackageList() {
                this.fetchData('/package/monthlist', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.packageList = res.data
                    } else {
                        this.$toast.fail('查询失败');
                    }
                })
            },
            queryCardStatus() {
                this.$toast.loading({message: '加载中', duration: 50000});
                this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                        if (res.data.change == 1) {
                            this.$dialog.alert({
                                title: "换卡提示",
                                message: res.data.changeMsg?res.data.changeMsg+'<div style="color: #ee0a24;font-weight: bolder">在网能正常使用的，点击取消即可</div>':"当前设备已不支持续费，我们将为您补发设备",
                                confirmButtonText: '立即申请',
                                showCancelButton: true
                            }).then(() => {
                                this.changeCard(this.iccid)
                            });

                        } else if (res.data.change == 2 && res.data.id) {

                            this.$dialog.alert({
                                title: false,
                                message: "您已申请换设备，点击查看进度",
                                confirmButtonText: '立即查看',
                                showCancelButton: true
                            }).then(() => {
                                this.$router.push({name: 'changeInfo', query: {id: res.data.id}})
                            }).catch(() => {
                            });

                        }
                        if(res.data.simStatusName) {
                          this.simStatusName = res.data.simStatusName;
                        }
                      this.simAuthStatus = res.data.simAuthStatus;
                      this.totalUsage = res.data.total;
                      this.remainUsage = res.data.remain
                      this.usedUsage = res.data.used
                      this.expireDate = res.data.expire
                      this.rebind = res.data.rebind
                      this.$nextTick(()=>{
                        this.initpage()
                      })
                        if(!res.data.change) {
                            if (res.data.activeLimit == 2) {

                                this.$dialog.alert({
                                    title: '温馨提示',
                                    message: '系统升级，请联系公众号客服'
                                }).then(() => {
                                    // on confirm
                                });
                                return false;
                            }
                            if (res.data.data && res.data.data.shuangka) {
                                this.shuangka = res.data.data.shuangka
                                if (!this.totalUsage) {
                                    //先续费再实名
                                    this.$dialog.confirm({
                                        title: '温馨提示',
                                        message: '当前设备无套餐，请先充值'
                                    }).then(() => {
                                        // on confirm
                                        this.handleRechargeBtnClick()
                                    }).catch(()=>{

                                    });
                                    //return false;
                                }
                                for (let i in this.shuangka) {
                                  this.shuangka[i].loading = true
                                    this.fetchData('/card/status', {iccid: this.shuangka[i].iccid}, (res) => {
                                        this.shuangka[i].loading = false
                                        this.shuangka[i].statusName = res.data.simStatusName;
                                        this.shuangka[i].auth = res.data.simAuthStatus;
                                        if (!this.showCopy && i=='yidong' && this.shuangka[i].auth == 0) {
                                            this.operator.authUrl = this.shuangka[i].authUrl
                                            this.showCopy = true
                                        }
                                        if (!this.showCopy && i =='dianxin' && (!this.shuangka.yidong || this.shuangka.yidong .auth == 1) && this.shuangka[i].auth == 0) {
                                          this.$dialog.confirm({
                                            message: '实名电信双网，网络更稳定'
                                          }).then(() => {
                                            window.location.href = this.shuangka[i].authUrl
                                          }).catch(() => {
                                            // on cancel
                                          });
                                        }

                                      if (!this.showCopy && i =='liantong' && (!this.shuangka.yidong || this.shuangka.yidong .auth == 1) && this.shuangka[i].auth == 0) {
                                        this.$dialog.confirm({
                                          message: '实名联通双网，网络更稳定'
                                        }).then(() => {
                                          this.showAuthDialog = true
                                        }).catch(() => {
                                          // on cancel
                                        });
                                      }
                                        this.$forceUpdate()
                                    })
                                }
                                /*this.fetchData('/card/deviceInfo', {iccid: this.iccid}, (res) => {
                                    this.deviceInfo = res.data
                                })*/
                            }

                            if (!this.simAuthStatus) {

                                if (this.operator.activeRule == 2 && !this.totalUsage) {
                                    //先续费再实名
                                    this.$dialog.confirm({
                                        title: '续费提示',
                                        message: '请续费后进行实名，以激活设备',
                                    }).then(() => {
                                        // on confirm
                                        this.handleRechargeBtnClick()
                                    }).catch(()=>{

                                    });
                                } else {
                                    this.showCopy = true
                                }
                            }
                        }
                    } else {
                        this.$toast.fail(res.msg)
                    }
                })
            },
            refresh() {
                this.queryPackageList();
                this.queryCardStatus();
            },
            /*queryResetImeiType() {
                this.fetchData('/card/resetImeiType', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.unbindNeedImei = res.data
                    }
                })
            },*/
            resetImei() {
                if (this.operator.imeiMsg) {
                    this.$dialog.confirm({
                        title: '注意',
                        message: this.operator.imeiMsg,
                    })
                        .then(() => {
                            this.doReset()
                        })
                        .catch(() => {
                            console.log('cancel')
                        });
                } else {
                    this.doReset()
                }
            },
            doReset() {
                if (this.operator.needImei == 0) {
                    //不需要上报imei
                    this.$toast.loading('解绑中')
                    let url
                    if (this.operator.autoImei == 1) {
                        url = '/card/active'
                    } else {
                        url = '/card/resetImei'
                    }
                    this.fetchDataPost(url, {iccid: this.iccid}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success(res.msg)
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })

                } else {
                    this.inputImeiModal = true;
                }
            },
            handleImeiInput() {
                if (!this.imei) {
                    this.$toast.fail('请输入IMEI');
                    this.close()
                } else {
                    let url
                    if (this.operator.autoImei == 1) {
                        url = '/card/active'
                    } else {
                        url = '/card/resetImei'
                    }

                    this.fetchDataPost(url, {iccid: this.iccid, imei: this.imei}, (res) => {
                        if (res.code) {
                            this.inputImeiModal = false;
                            this.$toast.success(res.msg)
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }
            },
            handleChooseCard(row) {
                this.iccid = row.value;
                this.cardModal = false;
            },
            handleWxUnbind() {
                this.$dialog.confirm({
                    message: '解绑后需重新绑定才能查询续费，确认解绑？'
                }).then(() => {
                    this.fetchDataPost('/card/unbindwx', {iccid: this.iccid}, (res) => {
                        if (res.code) {
                            this.$toast.success(res.msg)
                            this.queryUserCards()
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }).catch(() => {
                    console.log('cancel')
                });
            },
            showNextTips(item) {
                let msg = "这个套餐为次月套餐，如果想要立即使用，请点击确定以转成当月套餐，否则请点击取消";
                if (item.package.typeID == 5) {
                    msg = "这个套餐为次月套餐，，请点击确定以转成当月套餐，否则请点击取消。(转当月后，当前使用套餐立即失效)"
                }
                this.$dialog.confirm({
                    message: msg,
                    title: '提示'
                }).then(() => {
                    this.fetchDataPost('/order/recharge', {id: item.id}, (res) => {
                        if (res.code) {
                            this.$toast.success(res.msg)
                            this.refresh();
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }).catch(() => {
                    console.log('cancel')
                });
            },
            onCopySuccess() {
                this.$toast.success('复制成功')
            },
            onCopyError() {
                this.$toast.fail('复制失败，请手动长按复制');
            }
        }
    };
</script>
<style lang="scss" scoped>
.auth-modal{
  width: 6.5rem;
  margin: 0 auto;
  font-size: 0;
  padding: .4rem 0 3rem 0;
  .title{
    font-size: .3rem;
  }
  .auth-box{
    width: 6.4rem;
    margin: .2rem auto;
    .auht-item{
      display: inline-block;
      margin-left: .2rem;
      width: 2rem;
      color: #000;
      font-size: .28rem;
      border-radius: .1rem;
      text-align: center;
      background: #b3d5ff;
      padding:.14rem 0;
      .error{
        color: #ff1e58;
      }
      :first-child{
        margin-bottom: .1rem;
      }
    }
    :first-child{
      margin-left: 0;
    }
  }
}
.gongzhonghao{
  font-size: 0;
  height: inherit;
  background: linear-gradient(180deg, #ff8664,#c70003);
  .topimg{
    width: 7.5rem;
  }
  .buttom{
    position: fixed;
    bottom: 0;
    width: 7.5rem;
    background: #ffd8d8;
    padding: .8rem 0;
    border-top-left-radius: .6rem;
    border-top-right-radius: .6rem;
    .qrcode{
      width: 3.8rem;
      display: block;
      margin: 0 auto;
    }
    a{
      display: inline-block;
      width: 100%;
      margin-top: .4rem;
      text-align: center;
      font-size: .42rem;
    }
  }
}
.pagebottom{
  background: linear-gradient(-45deg, #FF9090FF,#ff1e58);
  padding: .4rem 0 .1rem 0;
  .box1{
    width: 6.5rem;
    padding: .2rem .2rem;
    margin: 0 auto .4rem;
    border-radius: .4rem;
    background: #ececec;
    font-size: 0;
    .title{
      font-size: .32rem;
      color: #000;
    }
    .btn-group{
      width: 6.2rem;
      margin: 0 auto 0;
      .btn-item{
        display: inline-block;
        width: 1rem;
        text-align: center;
        font-size: 0;
        margin-left: 1.6rem;
        margin-top: .2rem;
        position: relative;
        img{
          display: inline-block;
          width: .9rem;
          margin: 0 auto;
        }
        span{
          display: inline-block;
          margin-top: .1rem;
          font-size: .24rem;
          color: #000;
        }
      }
      .btn-item:nth-child(3n+1){
        margin-left: 0;
      }
    }
  }
}
.top{
  .last{
    margin-top: .4rem;
    display: flex;
    .amount{
      flex: 1;
      color: #fff;
      font-size: .28rem;
      div{
        display: block;
        text-align: center;
      }
      a{
        display: block;
        border-radius: .12rem;
        padding: .1rem 0;
        text-align: center;
        background: #fff;
        color: #69beff;
        margin-top: .08rem;
      }
    }
  }
  .status:nth-child(4){
    margin-top: .2rem;
  }
  .status:nth-child(5){
    margin-top: .2rem;
  }
  .status{
    width: 5.4rem;
    padding: .12rem .24rem;
    display: flex;
    background: #fff;
    font-size: .28rem;
    border-radius: .2rem;
    margin: 0 auto;
    color: #000;
    position: relative;
    .loading{
      position: absolute;
      left: 2.66rem;
      top: .16rem;
    }
    .success{
      color: #007d2f;
    }
    .error{
      color: #df1111;
    }
    .status-1{
      flex: 1;
      text-align: left;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .status-2{
      flex: 1;
      text-align: right;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .expire{
    font-size: .28rem;
    color: #fff;
    text-align: left;
    line-height: .8rem;
  }
  .iccid{
    font-size: .32rem;
    color: #fff;
    text-align: left;
    white-space: nowrap;
    .cp-btn{
      margin-left: .2rem;
      padding: .1rem .2rem;
      border-radius: .2rem;
      color: #69beff;
      background: #fff;

    }
  }
  padding: .6rem .5rem;
  background: -webkit-gradient(linear, left, right, from(#FF9090FF), to(#ff1e58));
  background: linear-gradient(115deg, #FF9090FF,#ff1e58);
  border-bottom: 3px solid #fff;
}


  .device-box{
    .title{
      border-bottom: 1px solid #666;
      display: flex;
      padding-bottom: .2rem;
      span:first-child{
        flex: 1;
        font-size: .26rem;
        text-align: left;
      }
      .wifi-btn {
        span{
          border: 1px solid #0b8ed4;
          border-radius: 4px;
          padding: 2px;
          color: #0b8ed4;
        }
      }
    }
    .wifi-box{
      .md-field-item-content{
        min-height: .6rem;
        height: .6rem;
        input{
          border: none;
          height: .5rem;
        }
        .md-field-item-title{
          font-size: .28rem;
        }
      }

      .md-button-content{
        width: 3rem;
        height: .4rem;
        text-align: center;
        font-size: .32rem;
        line-height: .4rem;
        background: #0b8ed4;
        color: #fff;
      }
    }
  }
  .change-tips {
    font-size: 13px;
    color: #3f3f3f;
    text-align: left;
    line-height: 20px;
  }

  .md-button {
    display: block;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.36rem;
    font-weight: 500;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    border-radius: 0.04rem;
    outline: 0px;
    transition: all 0.3s ease 0s;
    overflow: visible;
    position: relative;
  }

  .status-using {
    color: #2f86f6 !important;
  }

  .status-over {
    color: #9f9f9f !important;
  }

  .status-waiting {
    color: #9f9f9f !important;
  }

  .md-button.primary {
    background: #2f86f6;
    color: #fff;
  }

  .md-button.block {
    width: 100%;
  }

  .md-button.inactive {
    opacity: .3;
  }

  .md-button-inner {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    white-space: nowrap;
  }

  .query-content {
    background: #fff;
    font-size: .12rem;
    margin: .2rem auto;
    -webkit-box-shadow: 0 0 1px #dedede;
    box-shadow: 0 0 1px #dedede;
    border-radius: .1rem;
  }

  .package-list p span {
    line-height: 2;

    &:first-child {
      float: left;
    }

    &:last-child {
      float: right;
    }
  }

  .query-content .page-title {
    margin: .3rem 0 0 0;
    font-size: .3rem;
    height: .8rem;
    line-height: .8rem;
    border-radius: .2rem .2rem 0 0;
    border-bottom: 1px solid #fafafa;
    color: #888;
    text-align: center;
  }

  .page-content {
    padding-bottom: .1rem;
    min-height: 6rem;
  }

  .md-field {
    padding: .1rem .2rem;
    border: none;
  }

  .package-list {
    margin-top: .1rem;
  }

  .md-input-item-input {
    width: 100%;
    height: 1rem;
    color: rgb(17, 26, 52);
    font-size: 0.32rem;
    font-weight: 500;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
    line-height: 1;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    background: 0px 0px;
    outline: 0px;
  }

  imei-input {
    width: 4.8rem;
    text-align: center !important;
  }

  .md-field-item-content {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    min-height: 1rem;
    /*padding-top: .3rem;
    padding-bottom: .3rem;*/
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
  }

  .md-field-item-title {
    text-align: left;
    width: 1.6rem;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    font-size: .32rem;
  }

  .md-field-item-control {
    text-align: left;
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 0%;
    flex: 1 1 0%;
    color: #111a34;
    font-size: .32rem;
    font-weight: 500;
    padding: 0;
    margin: 0;
    line-height: 1.15;
    border: none;
    background: none;
    outline: none;
    border: 0;
  }

  .md-field-item-control a {
    margin: 0 .1rem;
    font-size: .26rem;
    color: #3a8ee6;
    white-space: nowrap;
  }

  #copy_phone {
    border: none;
    font-weight: 500;
    width: 100%;
    height: .36rem;
    font-size: .32rem;
    user-select: none;
  }

  #copy_phone:disabled {
    background: none;
  }

  .md-field-item-right {
    position: relative;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    margin-left: .12rem;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    color: #858b9c;
    font-size: .28rem;
  }


  .card-state {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 7rem;
    margin: .2rem auto 0;
  }

  .card-state .flow-item {
    font-size: .36rem;
    text-align: center;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .card-state .flow-item .item-title {
    color: #888;
    font-size: .26rem;
  }

  .card-state .flow-item .item-content {
    color: #333;
    font-size: .32rem;
  }

  .md-tab-bar {
    position: relative;
    padding-left: .4rem;
    padding-right: .4rem;
    background-color: #f9fafb;
  }

  .dot-gray {
    position: relative;
  }

  .card-state .flow-item .item-content .state-dot {
    margin-top: .08rem;
  }

  .dot-gray:after {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    -webkit-box-shadow: 0 0 0.1rem #888 inset;
    box-shadow: inset 0 0 0.1rem #888;
  }

  /*.dot-gray:after {
      width: .12rem;
      height: .12rem;
      background-color: #888;
      border-radius: 50%;
  }*/
</style>



// WEBPACK FOOTER //
// src/pages/index.vue